<template>
  <div class = "st-table">
    <el-card shadow="always" style="width: 100%">
      <el-form :model="search" label-position="top" label-width="" class = "el-form–label-top">
        <el-row :gutter="16">
          <el-col :span="6">
            <el-form-item label="Product Name">
              <el-select
                v-model="search.product_id"
                filterable
                clearable
                style="width: 80%"
              >
                <el-option
                  v-for="(item) in this.productList"
                  :key="item.index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="Assignee"
              :span="6"
            >
              <el-select
                v-model="search.assign_to_id"
                filterable
                clearable
                style="width: 80%"
                :loading="loading1"
              >
                <el-option
                  v-for="(item) in assigneeList"
                  :value="item.value"
                  :key="item.label"
                  :label="item.label"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Progress">
              <el-select
                v-model="search.progress"
                clearable
                style="width: 80%"
              >
                <el-option
                  v-for="item in this.progress"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>



        </el-row>
        <el-row type="flex" :gutter="16">
          <el-col :span="3">
            <el-button type="text" class="btn" @click="handleReset">
              Reset
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-button type="primary" class="btn" @click="getSummary">
              Search
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <br/>
    <el-card style="margin-top: 15px" class="echarts">
      <v-chart :options="task_summary" :autoresize="true" />
    </el-card>
  </div>

</template>

<script>
import productApi from "@/api/product";
import taskApi from "@/api/tasks"
import userApi from "@/api/user";

export default {
  name: "taskSummary",
  data() {
    return {
      productList:[],
      taskList:[],
      reqs:[],
      progressList:["Not started","In progress","Completed"],
      assigneeList:[],
      loading1: false,
      editIndex: -1,
      isEdit: -99,
      search: {
        product_id: '',
        assign_to_id: '',
        progress: '',
        pageSize: 10,
        totalPage: 0,
      },
      // progress: [{'value':0,'name':'Not started'},{'value':50,'name':'In progress'},{'value':100,'name':'Completed'}],
      progress: ['Not started','In progress','Completed'],
      task_summary:{
        title: [
          {
            text: 'Tasks Summary'
          }
        ],
        tooltip: {},
        legend: {
          data: ["Total Plan Hours", "Total Actual Hours"],
        },
        xAxis: {
          data: [],
        },
        yAxis: {
          minInterval:1
        },
        series: [
        ],
      },
    }
  },
  methods:{
    getSummary() {
      let param = {}
      if (this.search.product_id) {
        param['product_id'] = this.search.product_id
      }
      if (this.search.assign_to_id) {
        param['assign_to_id'] = this.search.assign_to_id
      }
      if (this.search.progress) {
        param['progress'] = this.search.progress
      }
      taskApi.getTaskSummary(param).then(
        res => {
          this.task_summary.xAxis.data = res['data']['data']['assignXAxis']
          this.task_summary.series = res['data']['data']['series']
        }
      )
    },
    getSelects() {
      userApi.getUsers().then(res=> {
        let users = res.data
        for (let user of users) {
          this.assigneeList.push({value: user.id, label: user['fullName']})
        }
      })
      productApi.getProducts().then(res=> {
          let products = res.data
          for (let product of products) {
            this.productList.push({value: product.id, label: product.name})
          }
        }
      )
    },
    handleReset() {
      this.search.assign_to_id = null
      this.search.project_id = null
      this.search.progress = null
    },

  },
  mounted(){
    this.getSelects()
    this.getSummary()
  },
}



</script>

<style scoped>
.echarts {
  margin: 0 auto;
  width:100%;
}
</style>
